<template>
    <List
        @update="$emit('update')"
        funcionalidade="livro-psicotropico"
    />
</template>

<script>
import List from '@/components/farmacia/livro/List'

export default {
    components: { List },
}
</script>